module.exports = __webpack_public_path__ + "img/feature-summary-background.2437c61.png";